import React from 'react';
import PropTypes from 'prop-types';

import MovieCard from 'components/cards/MovieCard';

import EntitiesPropTypes from 'utils/propTypes/entities';

const Entity = ({ type, entity, size }) => {
	let card = null;

	if (entity.status === 'published') {
		switch (type) {
			case 'movie':
				card = <MovieCard {...entity} data={entity} size={size} />;
				break;
			default:
				card = null;
		}
	}

	return card;
};

Entity.propTypes = {
	type: PropTypes.oneOf(['movie']).isRequired,
	entity: PropTypes.oneOfType([EntitiesPropTypes.broadcastItem]).isRequired,
	size: PropTypes.string
};

export default Entity;
